import { createFileRoute, notFound } from "@tanstack/react-router";

import { getCategoryPage } from "@/content/blog";
import {
  CONTENT_CACHE_CONTROL,
  CONTENT_NOT_FOUND_CACHE_CONTROL,
} from "@/content/cachePolicy";
import CategoryPage from "./-components/CategoryPage";
import { NotFoundPage } from "@/components/landing/LandingNotFound";

/**
 * `/blog-categories/:slug`, the six pages the published sitemap carries, and
 * what the blog's own category chips link to.
 */
export const Route = createFileRoute("/blog-categories/$slug")({
  loader: async ({ params }) => {
    const page = await getCategoryPage({ data: params.slug });
    if (!page) {
      throw notFound();
    }
    return page;
  },
  headers: ({ loaderData }) => ({
    "Cache-Control": loaderData
      ? CONTENT_CACHE_CONTROL
      : CONTENT_NOT_FOUND_CACHE_CONTROL,
  }),
  component: CategoryRoute,
  notFoundComponent: NotFoundPage,
});

function CategoryRoute() {
  const { category, posts } = Route.useLoaderData();
  return <CategoryPage category={category} posts={posts} />;
}
